import { render, staticRenderFns } from "./scope63.vue?vue&type=template&id=bbd3f3f2&scoped=true"
import script from "./scope63.vue?vue&type=script&lang=js"
export * from "./scope63.vue?vue&type=script&lang=js"
import style0 from "./scope63.vue?vue&type=style&index=0&id=bbd3f3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd3f3f2",
  null
  
)

export default component.exports